import React, { useState, useEffect } from 'react';
import { Row, Col, message } from 'antd';
import { API } from '../../../../../API/API';
import { MessageConst } from '../../../../../const/MessageConst';
import FieldText from '../../../../../components/FieldText/FieldText';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import FieldDate from '../../../../../components/FieldDate/FieldDate';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';

const HRDeductionNew = (props) => {

    const [initData] = useState({
        "deductionid": 0,
        "name": null,
        "enddate": null,
        "begindate": null
    });

    const [checkRule, setCheckRule] = useState(false);
    const [data, setData] = useState({ ...initData });
    const [loading, setLoading] = useState(false);

    const getExistsData = async () => {
        let tData = { ...initData };
        if (props.deductionid > 0) {
            try {
                setLoading(true);

                await API.post('/graphql/payroll', {
                    query: `query ($id: Int) {
                        sharedQuery {
                          gethrdeduction(id: $id) {
                            deductionid
                            name
                            begindate
                            enddate
                          }
                        }
                      }`,
                    variables: {
                        id: parseInt(props.deductionid)
                    }
                }).then(response => {
                    let tResp = response.data?.data?.sharedQuery?.gethrdeduction
                    if (response.status == 200 && tResp?.deductionid > 0) {
                        tData = tResp;
                    }
                });
            } finally {
                setLoading(false);
            }
        }
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [props.deductionid]);

    const onDismiss = () => {
        setData({ ...initData });
        setCheckRule(false);
        props.onDismiss();
    }

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }
    }

    const onSave = async () => {

        let vRule = true;
        let tData = { ...data };

        setCheckRule(true);

        if (!tData.name) {
            vRule = false;
        }

        if (vRule) {
            try {
                setLoading(true);
                await API.post('/graphql/payroll', {
                    query: `mutation ($data: hrdeductionInputType) {
                        sharedMutation {
                          savehrdeduction(data: $data) {
                            deductionid
                          }
                        }
                      }`,
                    variables: {
                        data: tData
                    }
                }).then(response => {
                    if (response.status == 200 && response?.data?.data?.sharedMutation?.savehrdeduction?.deductionid > 0) {
                        message.success(MessageConst.success);
                        props.afterSave();
                        onDismiss();
                    }
                });
            } finally {
                setLoading(false);
            }
        }
    }

    const onDelete = async () => {
        if (props.deductionid > 0) {
            await API.post('/graphql/payroll', {
                query: `mutation ($id: Int) {
                    sharedMutation {
                      deletehrdeduction(id: $id)
                    }
                  }`,
                variables: {
                    id: parseInt(props.deductionid)
                }
            }).then(response => {
                if (response.status == 200 && response.data?.data?.sharedMutation?.deletehrdeduction) {
                    message.success(MessageConst.success);
                    props.afterSave();
                    onDismiss();
                }
            });
        }
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                headerText={props.deductionid > 0 ? "Суутгал засах" : "Суутгал нэмэх"}
                onDismiss={onDismiss}
                buttons={
                    <div style={{ display: 'flex' }}>
                        {props.deductionid > 0 ? (
                            <div style={{ marginRight: 16 }}>
                                <ButtonSecondary text='Устгах' onClick={onDelete} />
                            </div>
                        ) : null}
                        <div>
                            <ButtonDefault text='Хадгалах' onClick={onSave} />
                        </div>
                    </div>
                }
            >
                <div>
                    <Row gutter={[16, 16]} style={{ marginTop: 25 }}>
                        <Col span={24}>
                            <FieldText loading={loading} required onChanged={fieldOnChanged} title="Суутгал нэр" keyfield='name' defaultValue={data.name} checkreq={checkRule} />
                        </Col>
                        <Col span={24}>
                            <FieldDate loading={loading} onChanged={fieldOnChanged} title="Эхлэх огноо" keyfield='begindate' defaultValue={data.begindate} />
                        </Col>
                        <Col span={24}>
                            <FieldDate loading={loading} onChanged={fieldOnChanged} title="Дуусах огноо" keyfield='enddate' defaultValue={data.enddate} />
                        </Col>
                    </Row>
                </div>
            </PanelBase>
        </div>
    );
}

export default HRDeductionNew;